<section class="main-section admin-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">NDR Summary</li>
    </ol>
  </nav>

  <div class="row align-items-end">
    <div class="col-10">
      <h2>NDR Summary</h2>
    </div>
  </div>

  <div class="row mb-4 ">
      <div class="col-md-12 col-lg-4">
        <div class="box" >
          <h6 class="mb-3">{{10}}</h6>
          <a>1<sup>st</sup> Attempt</a><br/>
        </div>
      </div>

      <div class="col-md-12 col-lg-4 " style="position: relative;">
        <div class="box inbound m-box">
          <h6 class="mb-3">{{20}}</h6>
          <a>2<sup>nd</sup> Attempt</a><br/>
        </div>
      </div>

      <div class="col-md-12 col-lg-4">
        <div class="box ">
          <h6 class="mb-3">{{5}}</h6>
          <a>3<sup>rd</sup> Attempt</a><br/>
        </div>
      </div>
  </div>

  <div class="row align-items-end">
    <div class="col-10">
      <h2>NDR Summary for Action</h2>
    </div>
  </div>
  <div class="row mb-4 ">
  <div class="col-md-12 col-lg-4 mt-3">
        <div class="box m-box">
          <h6 class="mb-3">{{10}}</h6>
          <a>1<sup>st</sup> Attempt</a><br/>
        </div>
      </div>
      <div class="col-md-12 col-lg-4 mt-3">
        <div class="box m-box">
          <h6 class="mb-3">{{20}}</h6>
          <a>2<sup>nd</sup> Attempt</a><br/>
        </div>
      </div>
    </div>

</section>
